import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {RegularPanel} from './EmbededPanel.react';
import urlMapping from '../app/URLMapping';
import EventTracker from '../app/EventTracker';
import LoadingButton from '../fw/LoadingButton.react';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import config from '../../common/config';
import StatusIcon from './box/StatusIcon.react';
import {getLocale} from '../locales';
import {lastPanelController} from './EmbededPanelController';
import openScreenSettings from './screen-settings/openScreenSettings';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import './Panels.scss';
import { User } from '../../common/types/types';

const messages = defineMessages({
    help: {id: 'panel.requiredCaching.help', 'defaultMessage': 'More about caching functionality'}
});

interface RequiredCachingProps {
    intl: IntlShape;
    location: object;
    user: User;
}

class RequiredCaching extends React.Component<RequiredCachingProps> {

    static propTypes = {
		intl: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }

    switchToSmall() {
        let urlObject = this.context.embededPanelController.getURLObject();
        let path = urlMapping.getUrl("panel", "error-mini", urlObject);
        this.context.router.push(path);
    }

    close = () => {
        this.switchToSmall();
    };

	enableCaching() {
		let path = urlMapping.getUrl('channels', "caching", {
			organisation_id: this.props.user.organisation.realId,
			id: this.props.user.organisation.channel.realId
		});

		window.open(config.PUBLIC_APP_URL + path, '_blank');
	}

    config = () => {
        lastPanelController().cancelMinimizePanel();

        let path = urlMapping.getUrl("panel", "screen-settings", lastPanelController().getURLObject());
        openScreenSettings(this.context.router, path);
    };

    render() {
		let channelName = this.props.user.organisation.channel.channelDef.name;

        return (
            <RegularPanel className="properHeight" close={this.close} config={this.config} hideMenu typeForTest="internal-error">
                <div className="bordered-content statusPanel">
                    <div className="embedLoading">
                        <div className="content">
							<strong>
								<FormattedMessage defaultMessage="Caching is required" id="panel.requiredCaching.title"/>
								&nbsp;&nbsp;
								<a href={"https://www.dativery.com/" + getLocale() + "/features/caching/"} target="_blank">
									<StatusIcon reactTooltip title={this.props.intl.formatMessage(messages.help)} type={StatusIcon.HELP} />
								</a>
							</strong><br/>
							<FormattedMessage defaultMessage="For proper functionality {product} has to cache data from {channelName}." id="panel.requiredCaching.description" values={{channelName: channelName, product: config.PRODUCT_NAME}} />
							<br />
							<LoadingButton className="btn btn-primary panelAction" onClick={() => { this.enableCaching(); }}>
								<span className="fa fa-cog" />
								{" "}
								<FormattedMessage defaultMessage="Enable caching for {channelName}" id="panel.requiredCaching.button" values={{channelName: channelName}}/>
							</LoadingButton>
                        </div>
                    </div>
                </div>
            </RegularPanel>
        );
    }
}


export default Relay.createContainer(injectIntl(RequiredCaching, (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        cachingChannelId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    ${EventTracker.getFragment()}
                    organisation(id: $organisationId) {
                        id,
                        realId,
                        channel(id: $cachingChannelId) {
                            id,
                            realId,
                            channelDef {
                                id,
                                realId,
                                name,
                                icon,
                            }
                        }
                    }
                }`;
        }
    }
});
